import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    // Check if it's a ResizeObserver error
    const errorMessage = error.message || '';
    if (errorMessage.includes('ResizeObserver') || 
        errorMessage.includes('loop completed') ||
        errorMessage.includes('undelivered notifications')) {
      // Don't show error UI for ResizeObserver errors
      return { hasError: false };
    }
    
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Check if it's a ResizeObserver error
    const errorMessage = error.message || '';
    if (errorMessage.includes('ResizeObserver') || 
        errorMessage.includes('loop completed') ||
        errorMessage.includes('undelivered notifications')) {
      // Suppress ResizeObserver errors
      console.log('ResizeObserver error suppressed:', error.message);
      return;
    }
    
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          color: 'white',
          background: 'rgba(26, 26, 46, 0.95)',
          borderRadius: '8px',
          margin: '20px'
        }}>
          <h2>Something went wrong.</h2>
          <p>Please refresh the page to try again.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              background: '#CC3333',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
